// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"842beed3","414":"dfedfa1f","796":"b8900d24"}[chunkId] + ".chunk.js";
};